namespace Gamification.Gamification {
    export namespace ProdottiLivelliService {
        export const baseUrl = 'Gamification/ProdottiLivelli';

        export declare function Create(request: Serenity.SaveRequest<ProdottiLivelliRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProdottiLivelliRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProdottiLivelliRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ProdottiLivelliRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/ProdottiLivelli/Create",
            Update = "Gamification/ProdottiLivelli/Update",
            Delete = "Gamification/ProdottiLivelli/Delete",
            Retrieve = "Gamification/ProdottiLivelli/Retrieve",
            List = "Gamification/ProdottiLivelli/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ProdottiLivelliService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
